// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.3.0",
  date: "2026-07-10T13:56:39.194Z",
  gitInfo: {
    dirty: false,
    raw: "0d609ca29",
    hash: "0d609ca29",
    distance: null,
    tag: null,
    semver: null,
    suffix: "0d609ca29",
    semverString: null
  }
};
/* tslint:enable */
